
export const config = {
  "property": "iCare",
  "building": "LAX",
  "copyright": "Copyright © 2018 Building Safety Solutions, Inc. (BSS) All Rights Reserved.",
  "title": "iCare LAWA Training Suite",
  "logo": "//s3-us-west-1.amazonaws.com/bss-guardian/assets/lax/lawa.png",
  "playlist": [
  {
    "title": "Module 1: Introduction",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Introduction.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-06.png",
    "text": "Introduction of the LAX brand statement and creating LAXceptional Xperiences by demonstrating iCARE standards",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/introduction.vtt"],
    "survey": "introduction",
    "activity": 'introduction'
  },
  {
    "title": "Module 2: Informative",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Informative.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-01.png",
    "text": "iCARE to be Informative showcasing all things LAX, its people, facilities, services and amenities\n",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/informative.vtt"],
    "survey": "informative",
    "activity": 'informative'
  },
  {
    "title": "Module 3: Courteous",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Courteous.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-02.png",
    "text": "iCARE to be Courteous exuding excitement and the warmth of LA",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/courteous.vtt"],
    "survey": "courteous",
    "activity": 'courteous'
  },
  {
    "title": "Module 4: Approachable",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Approachable.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-03.png",
    "text": "iCARE to be Approachable by creating exceptional memorable moments",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/approachable.vtt"],
    "survey": "approachable",
    "activity": 'approachable'
  },
  {
    "title": "Module 5: Responsive",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Responsive.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-04.png",
    "text": "iCARE to be Responsive by demonstrating integrity and empathy",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/responsive.vtt"],
    "survey": "responsive",
    "activity": 'responsive'
  },
  {
    "title": "Module 6: Efficient & Effective",
    "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Effective.mp4",
    "poster": "//d2bsj3sc0hks5v.cloudfront.net/icare/icons/LAX_CBT_Module+Icons-05.png",
    "text": "iCARE to be Efficient & Effective by respecting our guests’ time and experiences",
    "captions": ["//s3-us-west-2.amazonaws.com/bss-server/icare/cc/effective.vtt"],
    "survey": "efficient_effective",
    "activity": 'efficient_effective'
  },
]
}

export const ending = {
  "title": "Module 7: Ending",
  "src": "//s3-us-west-2.amazonaws.com/bss-server/icare/videos/Ending.mp4",
  "activity": 'ending',
  "captions": "//s3-us-west-2.amazonaws.com/bss-server/icare/cc/ending.vtt"
}



// WEBPACK FOOTER //
// ./src/config.js